import React from "react";

const SubscriptionPlans = () => {
  return (
    <div className="max-w-4xl mx-auto py-16">
      <h2 className="text-3xl font-bold text-center text-gray-900 mb-8">Nos Forfaits</h2>
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {/* Forfait Basique */}
        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-xl font-semibold text-blue-600">Forfait Basique</h3>
          <p className="mt-2 text-gray-600">Jusqu'à 5 utilisateurs, gestion de projets essentiels.</p>
          <p className="mt-4 text-3xl font-bold text-gray-900">199€</p>
          <p className="text-sm text-gray-500">par mois (30 jours d'essai gratuit)</p>
          <button className="mt-6 w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition">
            Choisir ce forfait
          </button>
        </div>
        {/* Forfait Pro */}
        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-xl font-semibold text-blue-600">Forfait Pro</h3>
          <p className="mt-2 text-gray-600">Jusqu'à 15 utilisateurs, projets illimités, support prioritaire.</p>
          <p className="mt-4 text-3xl font-bold text-gray-900">399€</p>
          <p className="text-sm text-gray-500">par mois (30 jours d'essai gratuit)</p>
          <button className="mt-6 w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition">
            Choisir ce forfait
          </button>
        </div>
        {/* Forfait Enterprise */}
        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-xl font-semibold text-blue-600">Forfait Enterprise</h3>
          <p className="mt-2 text-gray-600">Utilisateurs illimités, support dédié 24/7, solutions sur mesure.</p>
          <p className="mt-4 text-3xl font-bold text-gray-900">799€</p>
          <p className="text-sm text-gray-500">par mois (30 jours d'essai gratuit)</p>
          <button className="mt-6 w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition">
            Choisir ce forfait
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlans;
